var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSneakCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 40,
    viewBox: "0 0 117 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 110",
    d: "M43.2959 9.03416C59.6458 3.99012 111.679 8.38267 115.735 22.641C122.054 44.8538 1.22003 43.039 1.86677 20.1156C2.31589 4.1967 43.5909 -1.47224 75.3665 3.48914",
    stroke: "#99A943",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSneakCircle);
export default __webpack_public_path__ + "static/media/sneak-circle.683f0328743418ee5b99f47a08856163.svg";
export { ForwardRef as ReactComponent };